import * as yup from 'yup'

export const validateUpdateTax = yup.object().shape({
    name:yup
    .string()
    .min(2, 'El NOMBRE debe tener más de 1 caracteres'),
    value:yup
    .number().typeError('Campo requerido.')
    .positive()
    .min(0, 'Debe de utilizar un numero que no sea negativo'),
})
